import React,{useState} from 'react'
import HeaderOfstuDashComp from './subComponents/HeaderOfstuDashComp'
import SidebarOfsDash from './subComponents/SidebarOfsDash'
import { billInfoData, headerprops, notificationstuboxApi } from '../../../utils/DashboardApi/StudentDashboardApi'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import NotificationboxComp from '../commonSybcomponent/NotificationboxComp'
const StuDashBillComp = () => {
    const navigate = useNavigate()
    const handlePayNow=()=>{
        navigate('/studashboard/payment')
    }
    const [shownotificationbox,setshownotificationbox] = useState(false)
    
    function funcnotification(){
        
        setshownotificationbox(!shownotificationbox);
      }
  return (
    <>
        <div className="stu_dash_mainWrap">
        <SidebarOfsDash activeID="2"/>
        <div className="rightpartcontentwrap">
        <HeaderOfstuDashComp func={funcnotification} heading="Bill Info" myprops={headerprops} />
            {
                shownotificationbox == true ?
                <NotificationboxComp api={notificationstuboxApi}/>
                :
                ""
            }
            <div className="tabPane">
            <div className="tabpaneheightadjust tabpanebillinfo">
                    <div className="duepaymentpart">
                        <div className="headingofduepayment">
                            <h3>Due Payment <span>&#40;You have total 5 months tuition fee due&#41;</span></h3>
                        </div>
                        <div className="bottombuttondiv">
                            <Button onClick={handlePayNow}>Pay Now</Button>
                        </div>
                        <div className="duepaymenttable">
                            <table>
                                <thead>
                                    <tr>
                                        {
                                            billInfoData.duepayment.header.map((item,key)=>{
                                                return(
                                                    <th key={key}>{item.headerline}</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                      {
                                        billInfoData.duepayment.tabledata.map((item,key)=>{
                                            return(
                                                <tr key={key}>
                                                    <td>{item.sl}</td>
                                                    <td>{item.month}</td>
                                                    <td>{item.type}</td>
                                                    <td>{item.lastdate}</td>
                                                    <td>{item.dueamount}</td>
                                                </tr>
                                            )
                                        })
                                      }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="paymenthistory">
                        <div className="headingofpaymenthistory">
                            <h3>Previous Payment History</h3>
                        </div>
                        <div className="bottombuttondiv">
                            {/* <Button>Total Amount: {billInfoData.previouspayment.tabledata.map((item,key)=>{
                                var tempprevsum = tempprevsum + item.receivedamount
                                setprevsum(tempprevsum)
                                return(
                                    <>
                                    
                                    </>
                                )
                            })} {prevsum} BDT</Button> */}
                            <Button>Total 73604.00 BDT</Button>
                        </div>
                        <div className="paymenthistorytable">
                        <table>
                                <thead>
                                    <tr>
                                        {
                                            billInfoData.previouspayment.header.map((item,key)=>{
                                                return(
                                                    <th key={key}>{item.headerline}</th>
                                                )
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                      {
                                        billInfoData.previouspayment.tabledata.map((item,key)=>{
                                            return(
                                                <tr key={key}>
                                                    <td>{item.sl}</td>
                                                    <td>{item.billdate}</td>
                                                    <td>{item.periodname}</td>
                                                    <td>{item.type}</td>
                                                    <td>{item.payableamount}</td>
                                                    <td>{item.receivedamount}</td>
                                                </tr>
                                            )
                                        })
                                      }
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
       
            </div>
        </div>
    </div>
    </>
  )
}

export default StuDashBillComp